import { ComponentProps } from 'react';
import { ExternalLink } from 'lucide-react';

export function ToolAdCard({ className = '' }: ComponentProps<'div'>) {
    return (
        <a
            href="https://www.preciselighting.ng"
            target="_blank"
            rel="noopener noreferrer"
            className={`block h-full bg-[#274450] rounded-xl p-6 text-left hover:shadow-xl transition-all duration-300 hover:scale-105 border-2 border-transparent hover:border-[#3a6170] relative group text-decoration-none ${className}`}
        >
            <div className="absolute top-4 right-4 bg-white/10 backdrop-blur-sm text-white text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wider border border-white/20">
                Sponsored
            </div>

            <div className="bg-white w-14 h-14 rounded-lg flex items-center justify-center mb-4 p-2 shadow-sm">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    src="/images/ads/precise-lighting.webp"
                    alt="Precise Lighting"
                    width="56"
                    height="56"
                    className="w-full h-full object-contain"
                    loading="lazy"
                    decoding="async"
                />
            </div>

            <h3 className="text-xl font-bold mb-2 text-white flex items-center gap-2">
                Precise Lighting
                <ExternalLink className="w-4 h-4 opacity-50 text-white" />
            </h3>

            <p className="text-gray-200 text-sm mb-4">
                Shop premium lighting fixtures, chandeliers, and electrical accessories for your space.
            </p>

            <div className="text-white text-sm font-semibold flex items-center group-hover:underline">
                Visit Store →
            </div>
        </a>
    );
}
